import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { useFilterUIState } from '~/features/productsList/hooks';
import {
    StyledDynamicFiltersWrapper,
    StyledResponsiveTriggersJustIcons,
    StyledResponsiveTriggersJustIconsButton,
} from './styled';
import FilterIcon from '$icons/filter.svg';
import SortIcon from '$icons/sort.svg';

export const MobileFilterButtons = forwardRef<HTMLDivElement | null, unknown>((_props, ref) => {
    const {
        setIsFilterPanelOpen,
        setIsSortDrawerOpen,
        isSortDrawerOpen,
        setIsMobileFilterDrawerOpen,
    } = useFilterUIState();

    const filterTriggersRef = useRef<HTMLDivElement | null>(null);
    useImperativeHandle(ref, () => filterTriggersRef?.current as HTMLDivElement);
    return (
        <StyledDynamicFiltersWrapper>
            <StyledResponsiveTriggersJustIcons ref={filterTriggersRef}>
                <StyledResponsiveTriggersJustIconsButton
                    variant="primary"
                    shade="light"
                    size="md"
                    onClick={() => {
                        setIsFilterPanelOpen(true);
                        setIsMobileFilterDrawerOpen(true);
                    }}
                >
                    <FilterIcon aria-hidden="true" />
                </StyledResponsiveTriggersJustIconsButton>
                <StyledResponsiveTriggersJustIconsButton
                    variant="primary"
                    shade="light"
                    size="md"
                    onClick={() => {
                        setIsSortDrawerOpen(!isSortDrawerOpen);
                        setIsMobileFilterDrawerOpen(true);
                    }}
                >
                    <SortIcon aria-hidden="true" />
                </StyledResponsiveTriggersJustIconsButton>
            </StyledResponsiveTriggersJustIcons>
        </StyledDynamicFiltersWrapper>
    );
});
